import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { hasFeatureAccess } from '../utils/tierPermissions'

/**
 * Route guard component that checks if user has the required tier/feature access.
 * Redirects to dashboard with an upgrade prompt if access is denied.
 */
export default function TierProtectedRoute({ children, feature, redirectTo = '/dashboard' }) {
  const { user, isAuthenticated } = useAuthStore()

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Check if user has access to the required feature
  const userTier = user?.enrolled_tier
  const hasAccess = hasFeatureAccess(userTier, feature) || user?.is_admin || user?.role === 'instructor'

  // If no access, redirect with state to show upgrade prompt
  if (!hasAccess) {
    return (
      <Navigate 
        to={redirectTo} 
        replace 
        state={{ 
          showUpgradePrompt: true, 
          requiredFeature: feature,
          deniedAccess: true 
        }} 
      />
    )
  }

  // User has access, render the protected content
  return children
}
